// src/icons/AI.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function AI({
  strokeWidth = "2",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28",
      height: "28",
      viewBox: "0 0 28 28",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.4485 18.5547L10.5 21.875L9.5515 18.5547C9.30635 17.697 8.84672 16.9159 8.21597 16.2852C7.58522 15.6544 6.80416 15.1948 5.9465 14.9497L2.625 14L5.94533 13.0515C6.803 12.8064 7.58405 12.3467 8.2148 11.716C8.84555 11.0852 9.30518 10.3042 9.55033 9.4465L10.5 6.125L11.4485 9.44533C11.6936 10.303 12.1533 11.0841 12.784 11.7148C13.4148 12.3455 14.1958 12.8052 15.0535 13.0503L18.375 14L15.0547 14.9485C14.197 15.1936 13.4159 15.6533 12.7852 16.284C12.1544 16.9148 11.6948 17.6958 11.4497 18.5535L11.4485 18.5547ZM21.3022 10.1675L21 11.375L20.6978 10.1675C20.5249 9.47519 20.167 8.84289 19.6625 8.3382C19.1581 7.83351 18.5259 7.47541 17.8337 7.30217L16.625 7L17.8337 6.69783C18.5259 6.52459 19.1581 6.16649 19.6625 5.6618C20.167 5.15711 20.5249 4.52481 20.6978 3.8325L21 2.625L21.3022 3.8325C21.4752 4.52496 21.8332 5.15735 22.3379 5.66205C22.8426 6.16675 23.475 6.52478 24.1675 6.69783L25.375 7L24.1675 7.30217C23.475 7.47522 22.8426 7.83325 22.3379 8.33795C21.8332 8.84265 21.4752 9.47504 21.3022 10.1675ZM19.7097 23.9948L19.25 25.375L18.7903 23.9948C18.6615 23.6082 18.4444 23.2569 18.1562 22.9688C17.868 22.6806 17.5168 22.4635 17.1302 22.3347L15.75 21.875L17.1302 21.4153C17.5168 21.2865 17.868 21.0694 18.1562 20.7812C18.4444 20.493 18.6615 20.1418 18.7903 19.7552L19.25 18.375L19.7097 19.7552C19.8385 20.1418 20.0556 20.493 20.3438 20.7812C20.6319 21.0694 20.9832 21.2865 21.3698 21.4153L22.75 21.875L21.3698 22.3347C20.9832 22.4635 20.6319 22.6806 20.3438 22.9688C20.0556 23.2569 19.8385 23.6082 19.7097 23.9948Z",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  AI
};
